import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Cookies from "universal-cookie";
import ClipLoader from "react-spinners/ClipLoader";
import { css } from '@emotion/core';
import {
    FaUser,
    FaClipboardList,
    FaDonate,
    FaChevronRight,
    FaQuestion,
    FaAd,
    FaList
} from "react-icons/fa";
import Header from "../Components/Header";
import NewFooter from "../NewUI/newfooter";
import * as Constant from "../Constant";
import "./akun.css";

const override = css`
  display: block;
  margin: 0 auto;
  border-color: #ea6123 solid 2px;
`;

const Akun = () => {
    const [auth, setAuth] = useState(false);
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true); // Tambahkan state untuk loading
    const cookies = new Cookies();

    useEffect(() => {
        const accessToken = cookies.get("accessToken");
        if (accessToken) {
            fetch(`${Constant.GET_USER}`, {
                method: "GET",
                headers: {
                    Authorization: `${accessToken}`,
                },
            })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error("Failed to fetch user data");
                    }
                    return response.json();
                })
                .then((data) => {
                    const profilePicture = data.profile_picture
                        ? `${Constant.GET_PROFILE_PICTURE}${data.id}`
                        : "/profile-default.png";
    
                    setUser({ ...data, profile_picture: profilePicture });
                    setAuth(true);
                })
                .catch((error) => {
                    console.error(error);
                    setAuth(false);
                })
                .finally(() => {
                    setLoading(false);
                });
        } else {
            setLoading(false);
        }
    }, []);
    

    const handleLogout = () => {
        cookies.remove("id_yayasan", { path: "/" });
        cookies.remove("is_guest", { path: "/" });
        cookies.remove("user_id", { path: "/" });
        cookies.remove("username", { path: "/" });
        cookies.remove("accessToken", { path: "/" });
        setAuth(false);
        setUser(null);
    };

    return (
        <div>
            <Header />
            {loading ? (
                <div className="loading-container">
                    <ClipLoader css={override} size={150} color={"#ea6123"} loading={loading} />
                </div>
            ) : (
                <div className="profile-container-akun">
                    {auth && user && (
                        <div className="profile-header">
                            <img
                                src={user.profile_picture || "/profile-default.png"}
                                alt="Profile Picture"
                                className="profile-picture"
                            />
                            <h2>{user.name}</h2>
                        </div>
                    )}

                    {auth ? (
                        <div className="profile-buttons">
                            <Link to="/profilepage" className="profile-button">
                                <FaUser className="button-icon" />
                                <span className="button-text">Info Akun</span>
                                <FaChevronRight className="button-arrow" />
                            </Link>
                            <Link to="/rekap-santri" className="profile-button">
                                <FaClipboardList className="button-icon" />
                                <span className="button-text">Rekap Santri</span>
                                <FaChevronRight className="button-arrow" />
                            </Link>
                            <Link to="/riwayat_donasi" className="profile-button">
                                <FaDonate className="button-icon" />
                                <span className="button-text">Riwayat Donasi</span>
                                <FaChevronRight className="button-arrow" />
                            </Link>
                        </div>
                    ) : (
                        <div className="redirect-login">
                            <p>Silakan login untuk mengakses fitur lainnya.</p>
                            <Link to="/login" className="login-button">
                                Login
                            </Link>
                        </div>
                    )}

                    <div className="break">
                        <hr className="break-line" />
                    </div>

                    <div className="additional-buttons">
                        <Link to="/bantuan" className="profile-button">
                            <FaQuestion className="button-icon" />
                            <span className="button-text">Bantuan</span>
                            <FaChevronRight className="button-arrow" />
                        </Link>
                        <Link to="/tentang-kami" className="profile-button">
                            <FaAd className="button-icon" />
                            <span className="button-text">Tentang Kami</span>
                            <FaChevronRight className="button-arrow" />
                        </Link>
                        <Link to="/syarat-ketentuan" className="profile-button">
                            <FaList className="button-icon" />
                            <span className="button-text">Syarat dan Ketentuan</span>
                            <FaChevronRight className="button-arrow" />
                        </Link>
                    </div>

                    {auth && (
                        <div className="container-bottom">
                            <button onClick={handleLogout} className="profile-button logout">
                                Logout
                            </button>
                        </div>
                    )}
                </div>
            )}
            <NewFooter />
        </div>
    );
};

export default Akun;
